"use strict";
// Formatting utilities for consistent display across platforms
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncateText = exports.formatRelativeTime = exports.formatDuration = exports.formatCost = exports.formatSubscriptionTier = exports.formatCommunityLevel = exports.formatVerdict = exports.formatConfidenceScore = void 0;
const fact_check_1 = require("../types/fact-check");
const formatConfidenceScore = (score) => {
    if (score >= 90)
        return 'Very High Confidence';
    if (score >= 75)
        return 'High Confidence';
    if (score >= 60)
        return 'Moderate Confidence';
    if (score >= 40)
        return 'Low Confidence';
    return 'Very Low Confidence';
};
exports.formatConfidenceScore = formatConfidenceScore;
const formatVerdict = (verdict) => {
    // Delegates to the canonical map in types/fact-check — this helper previously
    // carried a third divergent wording ("Strongly Supported") alongside the app copies.
    return fact_check_1.VERDICT_LABEL[verdict] || verdict;
};
exports.formatVerdict = formatVerdict;
const formatCommunityLevel = (level) => {
    const levelMap = {
        'curious_observer': 'Curious Observer',
        'active_questioner': 'Active Questioner',
        'discerning_mind': 'Discerning Mind',
        'truth_seeker': 'Truth Seeker',
        'wisdom_guide': 'Wisdom Guide'
    };
    return levelMap[level] || level;
};
exports.formatCommunityLevel = formatCommunityLevel;
const formatSubscriptionTier = (tier) => {
    const tierMap = {
        'trial': 'Trial',
        'basic': 'Basic',
        'premium': 'Premium',
        'professional': 'Professional'
    };
    return tierMap[tier] || tier;
};
exports.formatSubscriptionTier = formatSubscriptionTier;
const formatCost = (costCents) => {
    const dollars = costCents / 100;
    if (dollars < 0.01)
        return '<$0.01';
    return `$${dollars.toFixed(2)}`;
};
exports.formatCost = formatCost;
const formatDuration = (milliseconds) => {
    if (milliseconds < 1000)
        return `${milliseconds}ms`;
    const seconds = milliseconds / 1000;
    if (seconds < 60)
        return `${seconds.toFixed(1)}s`;
    const minutes = seconds / 60;
    return `${minutes.toFixed(1)}m`;
};
exports.formatDuration = formatDuration;
const formatRelativeTime = (date) => {
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffSecs = Math.floor(diffMs / 1000);
    const diffMins = Math.floor(diffSecs / 60);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);
    if (diffSecs < 60)
        return 'just now';
    if (diffMins < 60)
        return `${diffMins}m ago`;
    if (diffHours < 24)
        return `${diffHours}h ago`;
    if (diffDays < 7)
        return `${diffDays}d ago`;
    return date.toLocaleDateString();
};
exports.formatRelativeTime = formatRelativeTime;
const truncateText = (text, maxLength = 100) => {
    if (text.length <= maxLength)
        return text;
    return `${text.substring(0, maxLength)}...`;
};
exports.truncateText = truncateText;
//# sourceMappingURL=formatting.js.map